import * as React from "react";
import { FieldProps } from "formik";
import { Form, Select, Input } from "antd";
 
const { Option } = Select;
const { TextArea } = Input;
const FormItem = Form.Item;
 
type OptionType = {
  index: number;
  label: string;
};
 
export const DropdownField: React.FC<
  FieldProps<any> & {
    label?: string;
    className?: string;
    disabled?: boolean;
    description?: string;
    options: OptionType[];
    placeholder?: string;
  }
> = ({
  field,
  form: { touched, errors, setFieldValue, setFieldTouched },
  label,
  className = "text-white",
  disabled = false,
  description,
  options,
  placeholder = "Select an option",
  ...props
}) => {
  const errorMsg = touched[field.name] && errors[field.name];
 
  const handleChange = (value: string | number) => {
    if (!disabled) {
      setFieldValue(field.name, value);
      setFieldTouched(field.name, true);
    }
  };
 
  const showTextarea = field.value === "Others";
 
  return (
    <>
      <FormItem
        className="!w-full text-[16px]"
        label={label}
      help=   {typeof errorMsg === "string"
                ? errorMsg
                : Array.isArray(errorMsg)
                ? errorMsg.join(", ")
                : null}
        validateStatus={errorMsg ? "error" : undefined}
      >
        <Select
          {...field}
          {...props}
          className={`${className} [&_.ant-select-selection-placeholder]:!text-white [&_.ant-select-selection-placeholder]:!opacity-80`}
          value={field.value}
          onChange={handleChange}
          onBlur={() => setFieldTouched(field.name, true)}
          disabled={disabled}
          placeholder={placeholder}
        >
          {options.map((opt) => (
            <Option key={opt.index} value={opt.label}>
              {opt.label}
            </Option>
          ))}
        </Select>
 
        {description && (
          <p className="mt-1 text-sm text-gray-400">{description}</p>
        )}
        <hr className="bg-[#77777] border w-full  border-[#7777]" />
      </FormItem>
 
      {showTextarea && (
        <FormItem
          className="!w-full "
          help={
            typeof touched["otherReason"] && errors["otherReason"] === "string"
              ? errors["otherReason"]
              : undefined
          }

      
          validateStatus={
            touched["otherReason"] && errors["otherReason"]
              ? "error"
              : undefined
          }
        >
          <TextArea
            rows={4}
            placeholder="Share your feedback..."
            onChange={(e) => setFieldValue("otherReason", e.target.value)}
            onBlur={() => setFieldTouched("otherReason", true)}
            style={{
              backgroundColor: "#3C3E58",
              borderRadius: "10px",
              color: "white",
              border: "none",
            }}
          />
        </FormItem>
      )}
    </>
  );
};